import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {
  AppBar,
  Box,
  CircularProgress,
  CssBaseline,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useState } from "react";

const Home = () => {
  const [loading, setLoading] = useState(true);

  const { signout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    signout();
    navigate("/");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <CssBaseline />

      <AppBar position="fixed" sx={{ backgroundColor: "black" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <img
            src="img/RD_EMPRESAS_BCO_GRANDE.png"
            alt="Logo"
            style={{ width: "180px" }}
          />
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon sx={{ mr: 0.5 }} />
            <Typography variant="body1" component="span">
              SAIR
            </Typography>
          </IconButton>
        </Toolbar>
      </AppBar>

      <Toolbar />

      <Box sx={{ position: "relative", flex: 1, overflow: "hidden" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "background.default",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1,
            }}
          >
            <CircularProgress sx={{ color: "red", mb: 2 }} />
            <Typography variant="h6" sx={{ color: "black" }}>
              Conectando ao Power BI...
            </Typography>
          </Box>
        )}

        <iframe
          title="RD Empresas"
          src={user?.urlEmbed}
          style={{ width: "100%", height: "100%", border: "none" }}
          allowFullScreen
          onLoad={() => setLoading(false)}
        />
      </Box>
    </Box>
  );
};

export default Home;
